<template>
  <!-- ORDER SWITCH -->
  <CustomSwitchWrapper
    data-test-id="signing-order-switch"
    :initial-value="createStore.ordered"
    inline
    :label="i18n.t('titles.define_order_of_signing')"
    label-class="drawer-subhead"
    :switch-id="i18n.t('titles.define_order_of_signing')"
    @click="onHandleOrderChanged"
    @value-changed="
      (value: boolean) => createStore.onOrderSwitchToggle(value, false, null)
    "
  />
  <!-- ORDER SWITCH -->
</template>
<script setup lang="ts">
import CustomSwitchWrapper from '@/components/inputs/CustomSwitchWrapper.vue';
import { useI18n } from 'vue-i18n';
import { useCreateStore } from '@/stores/create.ts';
import { computed, onBeforeMount, onBeforeUnmount, watch } from 'vue';

const createStore = useCreateStore();
const hasOrderBeenSetManually = computed(() => createStore.hasApprovers);
const i18n = useI18n();

function onHandleOrderChanged() {
  if (!createStore.ordered) {
    createStore.hasOrderBeenSetManually = true;
  }
}

onBeforeMount(() => {
  // Purely the document's grouping — mirrors isOrderedGrouping() in
  // useParticipantsReconcile, which captures the Confirm-time baseline. A
  // single group that carries a quorum deliberately stays OFF: the quorum
  // control now lives in the ungrouped view too (UnorderedInvitees), so
  // forcing the sequence ON to surface it would both misreport the document
  // and desync this flag from that baseline — which made Confirm see an order
  // change and issue a sign-order update that recreates the groups and wipes
  // the very quorum it was flipped for.
  const groups = createStore.signeesOrdered.filter((group) => group.length > 0);
  createStore.ordered = groups.length > 1;
});

onBeforeUnmount(() => {
  createStore.hasOrderBeenSetManually = false;
});

watch(hasOrderBeenSetManually, () => {
  // switch order off if user did not switch order manually ON AND if there are no approvers
  if (!createStore.hasApprovers) {
    createStore.onOrderSwitchToggle(false, false, null);
  }
});
</script>
